import { Takk } from "@mjolnerbacken/shared/types/takk";
import { useEffect, useMemo, useState } from "react";

import { H1 } from "../components/h1";
import { H2 } from "../components/h2";
import { Layout } from "../components/layout";
import { PrimeButton } from "../components/prime/button";
import { TakkImage } from "../components/takk-image";
import { useTakk, useTakkToday } from "../hooks/takk";
import { updateTakkToday } from "../services/takk-today";

export function Takk() {
  const { data: takk, isLoading: isLoadingTakk } = useTakk();
  const { data: takkToday, isLoading: isLoadingTakkToday } = useTakkToday();
  const [selectedTakks, setSelectedTakks] = useState<Takk[]>([]);

  const isLoading = useMemo(
    () => isLoadingTakk || isLoadingTakkToday,
    [isLoadingTakk, isLoadingTakkToday],
  );

  useEffect(() => {
    if (takkToday) {
      setSelectedTakks(takkToday);
    }
  }, [takkToday]);

  return (
    <Layout>
      {isLoading && <div>Loading...</div>}
      {!isLoading && (
        <>
          <H1>Takk</H1>
          <div className="flex gap-4 items-start w-full">
            <div className="w-1/2">
              <H2>Takk</H2>
              <PrimeButton
                label="Save"
                onClick={() => {
                  (async () => {
                    await updateTakkToday(selectedTakks.map((t) => t.id));
                    alert("Saved");
                  })();
                }}
              />
              <div className="flex flex-wrap gap-4">
                {takk?.map((t) => (
                  <TakkSelectableImage
                    key={t.id}
                    selected={selectedTakks.some((takk) => takk.id === t.id)}
                    takk={t}
                    onClick={() =>
                      selectedTakks.some((takk) => takk.id === t.id)
                        ? setSelectedTakks(
                            selectedTakks.filter((takk) => takk.id !== t.id),
                          )
                        : setSelectedTakks([...selectedTakks, t])
                    }
                  />
                ))}
              </div>
            </div>
            <div className="w-1/2">
              <H2>Preview</H2>
              <div className="flex flex-col gap-4 justify-center items-center">
                {selectedTakks.map((t) => (
                  <TakkImage key={t.id} takk={t} />
                ))}
              </div>
            </div>
          </div>
        </>
      )}
    </Layout>
  );
}

function TakkSelectableImage({
  takk,
  selected,
  onClick,
}: {
  takk: Takk;
  selected: boolean;
  onClick: () => void;
}) {
  return (
    <div
      className="cursor-pointer"
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          onClick();
        }
      }}
    >
      <TakkImage
        className={selected ? "outline outline-2 outline-red-500" : ""}
        takk={takk}
      />
    </div>
  );
}
